const useUidComponent = () => {
  const instance = getCurrentInstance();

  return { uuid: String(instance?.uid) };
};

export default useUidComponent;
